"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Factory = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const AdminView_1 = require("./views/AdminView");
class Factory {
    constructor() {
        this.name = null;
        this.studentView = null;
        this.adminView = null;
        this.TESTNAME = "classytest";
    }
    static getInstance(name) {
        if (Factory.instance === null) {
            Factory.instance = new Factory();
        }
        if (Factory.instance.name === null && typeof name !== "undefined") {
            Log_1.default.info("Factory::getInstance(..) - setting name: " + name);
            Factory.instance.name = name;
        }
        return Factory.instance;
    }
    getView(backendUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.studentView === null) {
                    Log_1.default.info("Factory::getView() - instantiating new student view for: " + this.name);
                    const plug = yield require("@plugs/CustomStudentView");
                    Log_1.default.trace("Factory::getView() - view loaded");
                    const constructorName = Object.keys(plug)[0];
                    this.studentView = new plug[constructorName](backendUrl);
                    Log_1.default.info("Factory::getView() - StudentView instantiated");
                }
            }
            catch (err) {
                Log_1.default.error("Factory::configureStudentView() - ERROR: " + err.message);
                Log_1.default.error("Factory::configureStudentView() - This likely means that your fork does not have a file called " +
                    "classy/plugins/{plugin}/portal/frontend/CustomStudentView.ts which should extend AbstractStudentView");
                this.studentView = null;
            }
            return this.studentView;
        });
    }
    getAdminView(backendUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const tabs = {
                deliverables: true,
                students: true,
                teams: true,
                results: true,
                grades: true,
                dashboard: true,
                config: true,
            };
            try {
                if (this.adminView === null) {
                    Log_1.default.info("Factory::getAdminView() - instantiating new admin view for: " + this.name);
                    const plug = yield require("@plugs/CustomAdminView");
                    Log_1.default.trace("Factory::getAdminView() - view loaded");
                    const constructorName = Object.keys(plug)[0];
                    this.adminView = new plug[constructorName](backendUrl, tabs);
                    Log_1.default.info("Factory::getAdminView() - AdminView instantiated");
                }
            }
            catch (_err) {
                Log_1.default.info("Factory::getAdminView() - custom admin view not provided; using default AdminView");
                this.adminView = new AdminView_1.AdminView(backendUrl, tabs);
            }
            return this.adminView;
        });
    }
    getName() {
        if (this.name === null) {
            Log_1.default.error("Factory::getName() - name requested before being set!");
        }
        return this.name;
    }
    getHTMLPrefix() {
        Log_1.default.trace("Factory::getHTMLPrefix() - getting prefix for: " + this.name);
        return this.name;
    }
}
exports.Factory = Factory;
Factory.instance = null;
